function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons / Files / upload");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 610,
  y: 602,
  width: 401,
  height: 501,
  rx: 6
}), React.createElement("filter", {
  x: "-3.6%",
  y: "-2.5%",
  width: "107.2%",
  height: "105.8%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.279541083   0 0 0 0 0.297286419   0 0 0 0 0.317566803  0 0 0 0.0906086101 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.326521894   0 0 0 0 0.331840511   0 0 0 0 0.337918931  0 0 0 0.11 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "6.-[Admin]-School-settings",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "[Admin]-School-Settings",
  transform: "translate(-788.000000, -851.000000)"
}, React.createElement("rect", {
  id: 123,
  fill: "#F7F7F7",
  x: 0,
  y: 1,
  width: 1026,
  height: 1792
}), React.createElement("g", {
  id: "Rectangle-Copy-4"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Group-8",
  transform: "translate(636.000000, 850.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Icons-/-Files-/-Download",
  transform: "translate(150.000000, 0.000000)"
}, React.createElement("path", {
  d: "M19.9794066,12.0387421 L19.9794066,7.21294023 C19.9794066,7.07481002 19.9133901,6.9471855 19.8200011,6.84621427 L14.2226957,1.16478349 C14.1182368,1.05855941 13.9696999,1 13.8213642,1 L4.94698834,1 C3.30865447,1 2,2.29142001 2,3.87524797 L2,20.0958175 C2,21.6796456 3.30865447,22.9498596 4.94698834,22.9498596 L11.9519729,22.9498596 C13.2769301,25.0757027 15.6853213,26.5 18.4288261,26.5 C22.5965142,26.5 26,23.22612 26,19.1923294 C26.0056174,15.6686478 23.3883085,12.7243347 19.9794066,12.0387421 Z M14.3712325,2.86553572 L18.1265193,6.68668368 L15.6907556,6.68668368 C14.9649777,6.68668368 14.3712325,6.1075096 14.3712325,5.40596391 L14.3712325,2.86553572 Z M4.94698834,21.8868408 C3.91890367,21.8868408 3.09973668,21.0895767 3.09973668,20.0958175 L3.09973668,3.87524797 C3.09973668,2.87604142 3.91890367,2.0630188 4.94698834,2.0630188 L13.2714959,2.0630188 L13.2714959,5.40596391 C13.2714959,6.69738387 14.3547285,7.74970248 15.6907556,7.74970248 L18.8796699,7.74970248 L18.8796699,11.9004173 C18.7148302,11.8951645 18.5827974,11.8792114 18.439896,11.8792114 C16.5209924,11.8792114 14.7560599,12.5914574 13.4254671,13.7075882 L6.44262219,13.7075882 C6.14011408,13.7075882 5.89275385,13.9466896 5.89275385,14.238903 C5.89275385,14.531311 6.14011408,14.7704124 6.44262219,14.7704124 L12.4028166,14.7704124 C12.0123537,15.3019218 11.6879073,15.8334312 11.4351128,16.4180526 L6.44262219,16.4180526 C6.14011408,16.4180526 5.89275385,16.6571541 5.89275385,16.9495621 C5.89275385,17.2417755 6.14011408,17.4810714 6.44262219,17.4810714 L11.0776581,17.4810714 C10.940191,18.0125809 10.8687403,18.6024552 10.8687403,19.1923294 C10.8687403,20.1489296 11.061154,21.0950241 11.4075388,21.8922882 L4.94698834,21.8922882 L4.94698834,21.8868408 Z M18.4344617,25.4424286 C14.8715886,25.4424286 11.9739113,22.6414986 11.9739113,19.1975822 C11.9739113,15.7536659 14.8659531,12.9527359 18.4344617,12.9527359 C22.0027691,12.9527359 24.8948109,15.7536659 24.8948109,19.1975822 C24.8948109,22.6414986 21.9973348,25.4424286 18.4344617,25.4424286 Z",
  id: "Shape",
  fill: "#959595"
}), React.createElement("path", {
  d: "M6.38159858,11.9285714 L11.5538852,11.9285714 C11.834807,11.9285714 12.0645161,11.7645628 12.0645161,11.5642857 C12.0645161,11.3638752 11.834807,11.2 11.5538852,11.2 L6.38159858,11.2 C6.10067684,11.2 5.87096774,11.3638752 5.87096774,11.5642857 C5.87096774,11.7645628 6.10067684,11.9285714 6.38159858,11.9285714 Z",
  id: "Path",
  fill: "#959595"
}), React.createElement("path", {
  d: "M18.4344617,25.4424286 C14.8715886,25.4424286 11.9739113,22.6414986 11.9739113,19.1975822 C11.9739113,15.7536659 14.8659531,12.9527359 18.4344617,12.9527359 C22.0027691,12.9527359 24.8948109,15.7536659 24.8948109,19.1975822 C24.8948109,22.6414986 21.9973348,25.4424286 18.4344617,25.4424286 Z",
  id: "Path",
  fill: "#959595"
}), React.createElement("path", {
  d: "M18.6669586,15.0087066 C18.5598059,14.9050981 18.4132192,14.8428571 18.2552773,14.8428571 C18.0973353,14.8428571 17.9507487,14.9050981 17.8435959,15.0087066 L14.5383769,18.2693372 C14.3240714,18.4767438 14.3410011,18.8084427 14.5666619,19.0002892 C14.7923227,19.1972591 15.1587893,19.1816989 15.3730949,18.974482 L17.7081581,16.6780173 L17.7081581,22.338721 C17.7081581,22.6239289 17.9618975,22.8571429 18.272207,22.8571429 C18.58231,22.8571429 18.8362559,22.6239289 18.8362559,22.338721 L18.8362559,16.6780173 L21.154183,18.974482 C21.2671166,19.0832139 21.4137032,19.1403314 21.5660708,19.1403314 C21.7013021,19.1403314 21.8367399,19.0936507 21.9494671,19.0002892 C22.1751279,18.8033192 22.1920577,18.4767438 21.9777521,18.2693372 L18.6669586,15.0087066 Z",
  id: "Path",
  fill: "#FFFFFF",
  transform: "translate(18.258065, 18.850000) scale(1, -1) translate(-18.258065, -18.850000) "
})))));

var SvgDownloadTemplate = function SvgDownloadTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownloadTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download_template.fa0afe83.svg";
export { ForwardRef as ReactComponent };